import { IMy } from "../../model/types";

export const hasFeature = (my: IMy, featureKey: string, targetUserId?: number) => {
    if(my.available_features.includes(featureKey)){
        return true
    }

    if(!my.feature_grants.length){
        return false
    }

    return my.feature_grants.some(featureGrant => {
        if(featureGrant.featureKey !== featureKey){
            return false
        }

        if(featureGrant.targetUserIds.length === 0){
            return true
        }

        if(targetUserId === undefined){
            return false
        }

        return featureGrant.targetUserIds.includes(String(targetUserId))
    })

}

/**
 * Checks that a feature is granted at least for one scope.
 *
 * Use this only before loading a list or an entity whose target user is not
 * known yet. The backend must still filter the returned entities by scope.
 * Actions on a known entity must use hasFeature with targetUserId instead.
 */
export const hasFeatureGrant = (my: IMy, featureKey: string) => {
    return my.available_features.includes(featureKey)
        || my.feature_grants.some(featureGrant => featureGrant.featureKey === featureKey)
}
